// The composed count phrases the case-file DOOR copy substitutes
// (act:22274f4d): {{other_companies}} and {{other_investigations}} are not
// stored values — they are built here from the live counts so one
// Ed-editable template stays truthful at any count. ONE home on purpose:
// three pages (Confirmation, Disqualified, QualForm's inline panel) spread
// this into their renderCopy vars, and the phrases must agree everywhere.
// TWO counts because the offerable set is keyed on CAMPAIGNS and one
// company can contribute two rows (CP3 boundary-man): the company phrase
// composes from the DISTINCT-company count, the investigation phrase from
// the campaign count. companyCount defaults to the campaign count so a
// caller that can't distinguish degrades to today's one-row-per-company
// reality rather than breaking.
// The parity spec (spec/frontend/funnel_chrome_copy_tokens_parity_spec.rb)
// parses this file's returned keys as part of each page's vars map, so
// adding a phrase here means adding the token to
// FirmDetail::CASE_FILE_DOOR_TOKENS in the same change.
export function caseFileCountVars(investigationCount, companyCount = investigationCount) {
  return {
    other_companies: companyCount === 1 ? "one other company" : `${companyCount} other companies`,
    other_investigations:
      investigationCount === 1
        ? "the other investigation"
        : `the other ${investigationCount} investigations`,
  }
}
